//
//
//
//
//
//
//
//
//
//
//
//

import Cropper from 'cropperjs'
import { uploadProfile } from '../../service/getData'

export default {
    name: 'upload-img',
    data() {
        return {
            img: '',
            imgsrc: '',
            crop: false,
            cropper: null
        }
    },
    methods: {
        readImg(e) {
            let self = this;
            let file = e.target.files[0];
            console.log(file)
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                self.imgsrc = this.result
                var imgD = document.getElementById('img');
                console.log(Cropper)
                imgD.onload = function() {
                    var cropper = new Cropper(imgD, {
                        aspectRatio:  1/1,
                        viewMode: 1,
                        dragMode: 'move',
                        cropBoxMovable: false,
                        cropBoxResizable: false,
                        minCropBoxHeight: 100,
                        minCropBoxWidth: 100,
                        minContainerWidth: window.screen.width,
                        minContainerHeight: window.screen.height
                    });
                    self.cropper = cropper;
                    self.crop = true;
                }
            }
        },
        upload() {
            var self = this;
            if(self.cropper) {
                alert('cropper' + self.cropper)
                self.cropper.getCroppedCanvas({width: 100, height: 100}).toBlob(function (blob) {
                    alert('blob' + blob.toString())
                    var form = new FormData();
                    form.append('avatarImg', blob, 'image.png');
                    alert('form' + form.toString() )
                    uploadProfile(form).then(function(res) {
                        alert('res' + res.toString())
                        if(res.data.status) {
                            var avatar = res.data.avatarImgUrl + '?' + Date.parse(new Date());
                            self.$store.dispatch('SET_AVATAR', avatar)
                            self.crop = false;
                            self.cropper.destroy();
                        }
                        console.log(res)
                    }).catch(function(error) {
                        console.log(error)
                    })
                })
            } 
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UpLoadProfile/index.vue